/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs */

const en_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Word To Previous Event`)
};

const fr_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers l'evenement precedent`)
};

const de_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort zum vorherigen Ereignis verschieben`)
};

const it_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la parola all'evento precedente`)
};

const ru_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить слово к предыдущему событию`)
};

const es_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover palabra al evento anterior`)
};

const zh_cn2_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将单词移至上一个事件`)
};

const ja_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を前のイベントに移動`)
};

const hi_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को पिछली घटना में ले जाएं`)
};

const pt_pt2_shortcut_keys_name_move_word_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover palavra para o evento anterior`)
};

/**
* | output |
* | --- |
* | "Move Word To Previous Event" |
*
* @param {Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_move_word_to_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_move_word_to_previous_event(inputs)
	return en_shortcut_keys_name_move_word_to_previous_event(inputs)
});